import { render, staticRenderFns } from "./setting-accountUsers.vue?vue&type=template&id=4aed3450&scoped=true&"
import script from "./setting-accountUsers.vue?vue&type=script&lang=js&"
export * from "./setting-accountUsers.vue?vue&type=script&lang=js&"
import style0 from "./setting-accountUsers.vue?vue&type=style&index=0&id=4aed3450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed3450",
  null
  
)

export default component.exports